import { Accordion, Text } from '@mantine/core';
import {
  SideBarContent,
  SideBarWrapper,
  StyledAccordion,
  StyledList,
} from './styles';
import { BlockItem, Header } from '../../molecules';
import { useStore } from '@/store';
import { useStructureBlocks } from '@morph-mapper/node-logic';
import { getEntries } from '@morph-mapper/utils';
// TODO: put import behind interface
import { STRUCTURE_CATEGORIES } from '@morph-mapper/node-logic';
import { t } from 'i18next';

export const SelectorView = () => {
  const variant = useStore(({ config: c }) => c.getVariant());
  const { structureBlocksByCategory } = useStructureBlocks(variant);

  return (
    <SideBarWrapper>
      <Header />
      <SideBarContent>
        <Text c="dimmed">{t('description.logicBlocks')}</Text>
        <StyledAccordion variant="separated" defaultValue="core">
          {getEntries(STRUCTURE_CATEGORIES).map(([category, title]) => (
            <Accordion.Item key={category} value={category}>
              <Accordion.Control>{t(title)}</Accordion.Control>
              <Accordion.Panel>
                <StyledList>
                  {/* TODO: convert to utils function: getValues */}
                  {Object.values(structureBlocksByCategory[category]).map(
                    ({ type }) => (
                      <BlockItem type={type} key={type} />
                    ),
                  )}
                </StyledList>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </StyledAccordion>
      </SideBarContent>
    </SideBarWrapper>
  );
};
